import { render, staticRenderFns } from "./QRCodeScanner.vue?vue&type=template&id=5f34340a&scoped=true&"
import script from "./QRCodeScanner.vue?vue&type=script&lang=js&"
export * from "./QRCodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeScanner.vue?vue&type=style&index=0&id=5f34340a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34340a",
  null
  
)

export default component.exports